import { render } from "./RecipesTab.vue?vue&type=template&id=708c00ed"
import script from "./RecipesTab.vue?vue&type=script&lang=js"
export * from "./RecipesTab.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__